// gordon-0915-froala-toolbar-kebab-ur-emoji-clipped-bullet-missing:
//
// Froala's own responsive fallback for a flat `toolbarButtons` array (used by
// every field that doesn't pass its own grouped `moreMisc` override --
// Wheel Name/Subtitle, the Text block/ImageWithText default array, ButtonsDesign,
// AccordionSettings) was `toolbarButtons.slice(0, 5).concat(["moreText"])` for
// narrow/XS widths, and the raw flat array (un-grouped, no overflow toggle at all)
// at normal width. Two independent bugs fall out of that:
//   1. "moreText" lands wherever index 5 happens to be -- for the shared default
//      array that's immediately after "italic" (index 4), not the toolbar's
//      right edge, because a flat array has no second `.fr-btn-grp` for the
//      `.fr-btn-grp:nth-child(2) { margin-left: auto }` toolbar CSS to push right.
//   2. everything past index 5 is silently dropped, not overflowed -- including
//      the bullet-list command (simpleUL) and, at normal (non-XS) width, the whole
//      array just wraps across multiple rows with no overflow toggle at all, so a
//      short/fixed-height toolbar clips whatever falls off the bottom (emoticons
//      in the default array).
//
// The Description field's own `moreMisc: { buttons, buttonsVisible }` override
// (PR#4802/#5237) already proves the fix: Froala renders the first `buttonsVisible`
// buttons in the normal row and the rest inside a second `.fr-btn-grp` -- the
// "more" toggle -- which the shared toolbar CSS pushes to the row's right edge,
// and nothing in the list is ever dropped (see
// feedback_froala_moremisc_overflow_clips_not_display_none). This applies that
// same grouped shape to every flat-array toolbar (both the normal and XS config)
// once it holds more real buttons than the proven single-row budget.

// Wheel Name/Subtitle's own array (5 real buttons: emoticons, specialCharacters,
// undo, redo, aiAssistant) is the longest flat array measured to never wrap at
// the Info-tab pane's narrowest tested width (see
// technique_froala_toolbar_wrap_measurement_and_builder_panel_race /
// gordonglitch-desctoolbarwraps-fixed-pr5237). Anything longer needs grouping.
export const FROALA_TOOLBAR_ROW_BUDGET = 5;

// 4 visible + 1 "more" toggle = 5, matching the same proven budget -- the exact
// value PR#5237 landed on for the Description field.
export const FROALA_GROUPED_BUTTONS_VISIBLE = 4;

/**
 * Converts a flat `toolbarButtons` array into Froala's grouped overflow format
 * once it's too long for one row, so the "more" toggle renders in the toolbar's
 * upper-right corner (via the existing `.fr-btn-grp:nth-child(2)` CSS) instead of
 * wherever a naive slice happens to land, and no button is ever silently dropped.
 * Arrays within the single-row budget, and configs that are already grouped
 * (an object, e.g. Description's own override), pass through unchanged.
 */
export function toResponsiveToolbarConfig(toolbarButtons) {
  if (!Array.isArray(toolbarButtons)) {
    return toolbarButtons;
  }

  const realButtons = toolbarButtons.filter((button) => button !== "|");
  if (realButtons.length <= FROALA_TOOLBAR_ROW_BUDGET) {
    return toolbarButtons;
  }

  return {
    moreMisc: {
      buttons: realButtons,
      buttonsVisible: FROALA_GROUPED_BUTTONS_VISIBLE,
    },
  };
}
